module.exports = __webpack_public_path__ + "41b6812c5f057518039bfb0cb681a57b.MP3";